<template>
  <div>
    <v-dialog v-model="dialog" hide-overlay width="444">
      <template v-slot:activator="{on}">
        <v-btn text rounded v-on="on">
          <span class="mr-2">Login</span>
          <v-icon>lock</v-icon>
        </v-btn>
      </template>
      <v-card class="pa-0 ma-0">
        <v-app-bar dark color="primary">
          <v-spacer></v-spacer>
          <v-icon left dark>lock</v-icon>
          <span class="title">Login Administrator</span>
          <v-spacer></v-spacer>
          <v-btn small dark icon color="accent" @click="close">
            <v-icon dark>close</v-icon>
          </v-btn>
          <div class="mr-1"></div>
        </v-app-bar>
        <v-container fluid>
          <v-form ref="form" class="pa-5">
            <v-row>
              <v-text-field
                v-model="data.username"
                aria-required
                label="Username"
                prepend-icon="person"
                :rules="r"
              ></v-text-field>
            </v-row>
            <v-row>
              <v-text-field
                aria-required
                label="Password"
                type="password"
                v-model="data.password"
                prepend-icon="lock"
                :rules="r"
              ></v-text-field>
            </v-row>
            <v-row class="mt-7" justify="center" align="center">
              <v-btn
                small
                rounded
                dark
                :disabled="loading"
                :loading="loading"
                color="primary"
                @click="save"
              >submit</v-btn>
              <div class="mx-2"></div>
              <v-btn small rounded dark color="error" @click="reset">reset</v-btn>
            </v-row>
          </v-form>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Swal from "sweetalert2";
import fs from "@/fb";
import bus from "@/main";
export default {
  data() {
    return {
      r: [v => !(v.length < 5) || "ID tidak valid."],
      dialog: false,
      loading: false,
      data: {
        username: "",
        password: ""
      }
    };
  },
  methods: {
    reset: function() {
      this.data = {
        username: "",
        password: ""
      };
    },
    save: async function() {
      try {
        if (this.$refs.form.validate()) {
          Swal.fire("Info", "Mencoba login keserver ...", "info");
          Swal.showLoading();
          this.loading = true;

          const r = await fs.user
            .where("username", "==", this.data.username)
            .where("password", "==", this.data.password)
            .get();
          await Swal.close();
          if (r.size > 0) {
            // login sukses
            const d = r.docs[0].data();
            const data = {
              id: r.docs[0].id,
              ...d
            };
            await this.$store.dispatch("setUser", data);
            bus.$emit("authChanged");
            this.dialog = false;
            this.reset();
            Swal.fire("Sukses", "Login sukses", "success");
          } else {
            // login gagal
            Swal.fire("Error", "ID anda tidak valid.", "error");
          }
          this.loading = false;
        }
      } catch (e) {
        console.log("Error");
        console.log(e);
      }
    },
    close: function() {
      this.reset();
      this.dialog = false;
    }
  }
};
</script>